import styled, { css } from "styled-components";
import stadium from "@/assets/stadium.png";
import field90 from "@/assets/field90.svg";
import { Link } from "react-router-dom";
export const GlobalWrapper = styled.div`
  margin: 0 24px;

  @media (max-width: 400px) {
    margin: 0 10px;
  }
`;

export const FakeBreadCrumb = styled.div`
  padding: 15px;
  margin: 16px 0;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 6px;
`;
export const BreadCrumbCont = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TeamWrapper = styled.div`
  display: flex;
  justify-content: center;
  background-image: url(${stadium});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 40px 0;
  border-radius: 5px;
  margin-bottom: 16px;
`;

export const TeamMatch = styled.div`
  display: flex;
  align-items: center;
  h3 {
    margin: 0 15px;
  }
  @media (max-width: 500px) {
    h3 {
      margin: 0 7px;
    }
  }
`;

export const IndividualTeam = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: center;

  @media (max-width: 500px) {
    p {
      font-size: 0.8rem;
    }
    gap: 5px;
  }
`;

export const TeamIcon = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  padding: 10px 25px;
  border-radius: 6px;
  img {
    object-fit: contain;
    width: 50px;
    height: 50px;
  }
  @media (max-width: 500px) {
    padding: 10px 15px;
    img {
      width: 35px;
      height: 35px;
    }
  }
`;

export const MetricsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 5px;
  padding: 15px;
  height: 100%;
`;

export const MetricsContainer = styled.div``;

export const GameStatistic = styled.div<{
  homePoints: number;
  awayPoints: number;
}>`
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  span {
    padding: 0px 4px;
    border-radius: 3px;
  }

  ${(props) =>
    props.homePoints > props.awayPoints
      ? css`
          span:first-child {
            background-color: #325176;
          }
        `
      : props.awayPoints > props.homePoints
      ? css`
          span:last-child {
            background-color: #993232;
          }
        `
      : ""}
`;

export const FieldWrapper = styled.div`
  img {
    width: 100%;
  }
`;

export const FieldCont = styled.div`
  position: relative;
  /* background: url(${field90}); */
`;
export const ShirtsCont = styled.div<{ position: string; isHome?: boolean }>`
  display: flex;
  justify-content: center;
  position: absolute;
  align-items: center;

  @media (min-width: 700px) {
    flex-direction: column;
    top: 0px;
    ${(props) =>
      props.isHome ? `left: ${props.position};` : `right: ${props.position};`}
    height: 100%;
    width: unset;
    p {
      width: 75px !important;
    }
  }

  ${(props) =>
    props.isHome ? `top: ${props.position};` : `bottom: ${props.position};`}
  gap: 15px;
  width: 100%;
  a {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: ${(props) => props.theme.fontColor};
    text-decoration: none;
  }

  a:hover {
    opacity: 0.7;
  }

  img {
    max-width: 100%;
    width: 30px;
  }

  p {
    width: 60px;
    text-align: center;
    font-size: 0.7rem;
  }

  h2 {
    display: flex;
    justify-content: center;
    position: absolute;
    font-size: 15px;
    width: 100%;
    margin-top: 7px;
  }

  @media (max-width: 400px) {
    gap: 0px;
    img {
      width: 25px;
    }

    h2 {
      font-size: 0.9rem;
      margin-top: 5px;
      margin-left: 1px;
    }
  }
`;

export const HomeTeamCont = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 10px;
  div:first-child {
    padding: 5px 10px;
    background-color: #325176;
    border-radius: 5px;
  }

  div:last-child {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
  }
  img {
    max-width: 100%;
    object-fit: contain;
    width: 40px;
    height: 40px;
  }
`;

export const AwayTeamCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 10px;
  div:last-child {
    padding: 5px 10px;
    background-color: #993232;
    border-radius: 5px;
  }

  div:first-child {
    display: flex;
    flex-direction: column;
    margin-right: 10px;
  }
  img {
    max-width: 100%;
    object-fit: contain;
    width: 40px;
    height: 40px;
  }
`;

export const EstimatesWrapper = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 24px;
  border-radius: 5px;
  height: 100%;
  div {
    display: flex;
    justify-content: space-between;
    padding: 8px;
    border-bottom: 1px solid ${(props) => props.theme.topElementsColor};
  }

  div:first-child {
    color: ${(props) => props.theme.fontColor}32;
  }
`;

export const GraphicsWrapper = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 24px;
  border-radius: 5px;
`;

export const GraphicsContainer = styled.div`
  h3 {
    text-align: left;
  }
`;

export const scoresH2hContainer = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 24px;
  border-radius: 5px;
  height: 100%;
`;

export const StatsContainer = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.topElementsColor};
  margin-bottom: 16px;
  overflow: auto;
`;

export const HistoryTable = styled.table`
  width: 100%;
  border-spacing: 0px 10px;
`;

export const TableHead = styled.tr`
  th:not(:last-child) {
    text-align: center;
  }

  th:first-child {
    width: 2%;
  }

  th:nth-child(2) {
    width: 10%;
    padding-left: 5px;
  }
  th:nth-child(3) {
    width: 15%;
    padding-left: 5px;
    text-align: left;
  }

  th:last-child {
    text-align: right;
  }
  @media (max-width: 500px) {
    th:nth-child(2) {
      width: 20%;
    }
  }
`;

export const TableData = styled.tr`
  padding-top: 10px;
  td {
    text-align: center;
  }

  td:last-child {
    text-align: right;
  }
  td:nth-child(2) {
    display: flex;
    justify-content: center;
  }

  img {
    width: 30px;
    object-fit: contain;
  }
`;

export const MatchesTable = styled.div`
  span {
    padding: 0 15px;
  }
  span:first-child {
    border-radius: 5px 0px 0px 5px;
  }
  span:last-child {
    border-radius: 0px 5px 5px 0px;
  }

  @media (max-width: 500px) {
    span {
      padding: 0 10px;
    }
  }
`;

export const H2hSpan = styled.span<{ stats: string }>`
  ${(props) => {
    if (props.stats === "V") {
      return "background-color: #2af497;";
    }

    if (props.stats === "D") {
      return "background-color: red;";
    }

    if (props.stats === "E") {
      return "background-color: gray;";
    }
  }}
`;

export const BetsOnMatch = styled.div`
  padding: 24px;
  background-color: ${(props) => props.theme.backgroundColor};
  h2 {
    margin-bottom: 24px;
  }
  .MuiAccordion-root {
    margin: 16px 0;
  }

  @media (max-width: 400px) {
    padding: 10px;
  }
`;

export const BetNames = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 0;
  p {
    background: linear-gradient(130deg, #018d3a, #029f43);
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 12px;
  }
`;

export const BetCardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
`;

export const BetCardCont = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  width: 100%;
  padding: 16px;
  border-radius: 5px;
  p {
    text-align: end;
    font-size: 0.8rem;
  }
`;

export const NotFound = styled.div`
  text-align: center;
  margin-top: 16px;

  p {
    color: ${(props) => props.theme.fontColor}80;
    font-weight: bold;
  }
`;

export const CardPillCont = styled.div`
  text-align: center;
`;
export const BetCardPill = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) => props.theme.bottomColor};
  padding: 8px;
  border-radius: 5px;
  margin-bottom: 10px;
  span {
    display: flex;
    align-items: center;
  }
  div {
    background: linear-gradient(130deg, #018d3a, #029f43);
    padding: 3px;
    border-radius: 5px;
    width: fit-content;
    margin-right: 5px;
  }
`;

export const LineUpsWrapper = styled.div`
  padding: 24px;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 5px;
`;

export const SmallLineUp = styled.small`
  color: ${(props) => props.theme.secondaryFont};
`;

export const PlayersWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PlayersCont = styled(Link)<{ color: string; noMargin?: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 12px;
  background-color: ${(props) => props.theme.bottomColor};
  border-radius: 5px;
  max-width: 100%;
  border: none;
  width: 100%;
  color: ${(props) => props.theme.fontColor};
  text-decoration: none;
  ${(props) => (props.noMargin ? "" : "margin-bottom: 16px;")}

  &:hover {
    opacity: 0.7;
  }

  div:first-child {
    width: 8px;
    border-radius: 5px;
    background-color: ${(props) => props.color};
    margin-right: 5px;
    align-self: normal;
  }

  div:nth-child(2) {
    text-align: left;
  }

  h3 {
    margin-left: auto;
  }
`;


export const TitleSection = styled.div `
  display:flex;
  align-items: center;

  button {
    background: none;
    border: none;
    transform: translate(8px, -8px);
  }
`